import { render, staticRenderFns } from "./empty-cart.vue?vue&type=template&id=cac9731c&scoped=true"
import script from "./empty-cart.vue?vue&type=script&lang=js"
export * from "./empty-cart.vue?vue&type=script&lang=js"
import style0 from "./empty-cart.vue?vue&type=style&index=0&id=cac9731c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac9731c",
  null
  
)

export default component.exports